import React, { useEffect } from 'react'
import { BrowserRouter as Router} from 'react-router-dom'
import { useRoutes } from './routes'
import { ModalDisconnect } from './pages/elements/ModalDisconnect'
import { ErrorBoundary } from './components/ErrorBoundary'
import { useAuth } from './hooks/auth.hook'
import { AuthContext } from './context/AuthContext'
import { UserContext } from './context/UserContext'
import { SFXContext } from './context/SFXContext'
// import { LayoutContext } from './context/LayoutContext'
import { useSettings } from "./hooks/settings.hook"
import { usePlaying } from "./hooks/isPlaying.hook"
import { useDisconnect } from "./hooks/disconnection.hook"
import { useAudio } from "./hooks/audio.hook"
import { useChat } from "./hooks/chat.hook"
import { useBell } from "./hooks/notifications.hook"
import { useFullScreen } from './hooks/fullscreen.hook'
import { useGameRedirect } from './hooks/game.redirect.hook'
import { useIsMobile } from './hooks/isMobile.hook'
// import { useBoardSize } from './hooks/board.size.hook'

import io from "socket.io-client"
import 'react-toastify/dist/ReactToastify.css';

const storageName = 'userData'
// mts

// const socket = io('http://192.168.1.101:4000', {
//   auth: async (cb) => {
//     const data = await JSON.parse(localStorage.getItem(storageName))
//     cb({
//       token: data?.token,
//       sid: data?.sid
//     })
//   },
//   forceNew: false,
//   withCredentials: true
// }) 

const socketUrl = process.env.REACT_APP_SOCKET_URL || (process.env.NODE_ENV === 'development' ? 'http://192.168.0.101:4000' : undefined)
const socket = io(socketUrl, {
  auth: async (cb) => {
    const data = await JSON.parse(localStorage.getItem(storageName))
    cb({
      token: data?.token,
      sid: data?.sid
    })
  },
  forceNew: false,
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000
}) 

// moskovia
// const socket = io('http://192.168.88.57:4000', {
//   auth: async (cb) => {
//     const data = await JSON.parse(localStorage.getItem(storageName))
//     cb({
//       token: data?.token,
//       sid: data?.sid
//     })
//   },
//   forceNew: false,
//   withCredentials: true
// }) 

//production

// const socket = io({
//   auth: async (cb) => {
//     const data = await JSON.parse(localStorage.getItem(storageName))
//     cb({
//       token: data?.token,
//       sid: data?.sid
//     })
//   },
//   forceNew: false,
    // withCredentials: true,
    // reconnection: true,
    // reconnectionAttempts: Infinity,
    // reconnectionDelay: 1000,
    // reconnectionDelayMax: 5000
// })

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

window.checkMozilla = function() {
  let check = false;
  if(navigator.userAgent.toLocaleLowerCase().indexOf('firefox') > -1) {check = true}
  return check
}

// Global game redirect component - must be inside <Router> for useNavigate to work
function GlobalGameRedirect({socket}) {
  useGameRedirect(socket)
  return null
}

function App() {
  // add offline mode with Play bot availiable, game history of last 30 games?
  const {token, login, logout, userId, nick, isAuthenticated, isAdmin} = useAuth(socket)
  const {settings, setSettings} = useSettings()
  const {chatOpened, setChatOpened, typing, setTyping, messages, setMessages} = useChat()
  const {isPlaying, setIsPlaying} = usePlaying()
  const {notificationsOpen, setNotificationsOpen} = useBell()
  const {isOnline} = useDisconnect(socket)
  const {playBullet, playMove, playTick, playGong, playScream, playDavid, playTournamentFinish, playWithdraw} = useAudio()
  const isFullScreen = useFullScreen()
  
  // const {width, height, gameBoard, fullBoard, totalHeight, keyboard, isMobile, isFirefox} = useBoardSize()
  // const height = window.innerHeight
  const isFirefox = window.checkMozilla()
  // `isMobile` is UA-only (drives phone-specific keyboard hacks).
  // `isCompact` is UA-OR-narrow-width and drives which Game shell renders
  // (mobile vs desktop). Body class also follows `isCompact`.
  const { isMobile, isCompact } = useIsMobile()

  // Listen for tab visibility changes:
  // - When hidden: tell SW to start heartbeat (keeps Socket.IO alive in background)
  // - When visible: stop SW heartbeat, notify server tab is active
  useEffect(() => {
    const sw = navigator.serviceWorker

    // Handle heartbeat wakeup from service worker
    const handleSWMessage = (event) => {
      if (event.data?.type === 'SW_HEARTBEAT' && socket?.connected) {
        // This fires even in background tabs. The act of emitting
        // generates transport activity, resetting the server's ping timer.
        // volatile = drop if transport not ready (don't buffer while offline)
        socket.volatile.emit('sw-heartbeat')
      }
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        // Tab came back to foreground — stop SW heartbeat
        sw?.controller?.postMessage({ type: 'STOP_HEARTBEAT' })
        if (socket?.connected) {
          // Probe connection liveness: ack must arrive within 1.5s
          socket.timeout(1500).emit('tab-active', (err) => {
            if (err) {
              // Transport is dead (zombie) — force fresh reconnect
              socket.disconnect()
              socket.connect()
            }
          })
        } else if (socket) {
          // Socket disconnected while in background. The auto-reconnect
          // may be sitting on a backoff timer (1-5s). Bypass it:
          // disconnect() cancels pending timers and resets backoff,
          // then connect() starts a fresh attempt immediately.
          socket.disconnect()
          socket.connect()
        }
      } else {
        // Tab went to background — start SW heartbeat to keep connection alive
        sw?.controller?.postMessage({ type: 'START_HEARTBEAT' })
      }
    }

    sw?.addEventListener('message', handleSWMessage)
    document.addEventListener('visibilitychange', handleVisibilityChange)

    // If already hidden on mount (e.g. opened in background tab), start immediately
    if (document.visibilityState === 'hidden' && sw?.controller) {
      sw.controller.postMessage({ type: 'START_HEARTBEAT' })
    }

    return () => {
      sw?.removeEventListener('message', handleSWMessage)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      sw?.controller?.postMessage({ type: 'STOP_HEARTBEAT' })
    }
  }, [socket])

  // useEffect(()=> {
  //   socket.on('connect', ()=> {
  //     socket.emit('startHeartbeat')
  //   })

  //   socket.on('heartbeat', () => {})
  // },[socket])

  // function sendMoveAPI (id, gameId, moveName, round, moveNumber) {
  //   if (!socket) {
  //     console.log('there is no socket here')
  //     return
  //   }
  //   console.log('sending move', moveNumber, moveName, 'to', id, gameId )
  //   socket.emit('otb-move-made', id, gameId, round, moveName, moveNumber)
  // }

  // window.sendMoveAPI = sendMoveAPI


  return (
    <AuthContext.Provider value = {{token, userId, login, logout, isAuthenticated, socket, isAdmin}}>
      <Router>
        <GlobalGameRedirect socket={socket}/>
        <UserContext.Provider value = {{nick, isOnline, isPlaying, setIsPlaying, settings, setSettings, chatOpened, setChatOpened, typing, setTyping, setNotificationsOpen, notificationsOpen, messages, setMessages, isFirefox, isMobile, isCompact, isFullScreen}}> 
          {/* <LayoutContext.Provider value = {{isMobile, width, height, gameBoard, fullBoard, totalHeight, keyboard, isFullScreen, isFirefox, isFullScreen}}>       */}
            <SFXContext.Provider value = {{playBullet, playMove, playTick, playGong, playScream, playDavid, playTournamentFinish, playWithdraw}}>
              <ErrorBoundary>
                {useRoutes(isAuthenticated, isAdmin)}
              </ErrorBoundary>
              {!isOnline ? <ModalDisconnect/> : <></>}
            </SFXContext.Provider>
          {/* </LayoutContext.Provider> */}
        </UserContext.Provider> 
      </Router>
    </AuthContext.Provider>
  )
}

export default App;
